function IconInsta() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="922"
      height="1024"
      viewBox="0 0 922 1024"
    >
      <title />
      <g id="icomoon-ignore" />
      <path d="M918.851 327c-3.4-71.8-19.799-135.4-72.402-187.8-52.398-52.4-115.999-68.8-187.796-72.4-74.004-4.2-295.802-4.2-369.802 0-71.6 3.4-135.2 19.8-187.8 72.2s-68.8 116-72.4 187.8c-4.2 74-4.2 295.802 0 369.802 3.4 71.798 19.8 135.398 72.4 187.796 52.6 52.403 116 68.803 187.8 72.402 74 4.198 295.798 4.198 369.802 0 71.798-3.4 135.398-19.799 187.796-72.402 52.403-52.398 68.803-115.999 72.402-187.796 4.198-73.999 4.198-295.602 0-369.602z" />
      <path
        fill="#fff"
        d="M244.042 511.804c0-127.2 102.6-229.8 229.8-229.8s229.8 102.6 229.8 229.8c0 127.198-102.6 229.802-229.8 229.802s-229.8-102.605-229.8-229.802z"
      />
      <path
        fill="#fff"
        d="M713.042 326.204c29.599 0 53.601-23.8 53.601-53.6 0-29.6-24.003-53.6-53.601-53.6s-53.601 24-53.601 53.6c0 29.6 23.803 53.6 53.601 53.6z"
      />
      <path d="M324.438 511.8c0 82.402 67.2 149.402 149.4 149.402s149.4-67 149.4-149.402c0-82.4-67-149.4-149.4-149.4s-149.4 67-149.4 149.4z" />
    </svg>
  );
}

export { IconInsta };
